module.exports = __webpack_public_path__ + "static/visionar_grade_021-5b0709e0df50aa8529b8312dd3cd486b.png";